<script lang="ts">
  import { onMount } from "svelte";
  import { poiStore } from "$lib/stores/pois.svelte";
  import MapControl from "./map-control.svelte";
  import MapLoadScreen from "./map-load-screen.svelte";
  import { hungaryPlacesSearch } from "$lib/helpers/place-search.service";
  import { MapManager } from "$lib/components/map/helpers/MapManager";
  import { getInitialMapState, MAP_CONFIG } from "./helpers/config";

  let { popupElement = $bindable(), firstLoadFinish = $bindable() } = $props();

  let placesDataLoaded = $state(false);
  let loadingProgress = $state(0);
  let mapElement: HTMLDivElement;
  // svelte-ignore non_reactive_update
  let mapManager: MapManager;

  onMount(() => {
    requestAnimationFrame(async () => {
      await initializeMap();
      loadPlacesData();
    });

    return cleanup;
  });

  async function initializeMap(): Promise<void> {
    const { center, zoom } = getInitialMapState();

    try {
      mapManager = new MapManager(mapElement, center, zoom);
      await mapManager.initialize();
    } catch (error) {
      console.error("Failed to initialize map:", error);
    }
  }

  async function loadPlacesData(): Promise<void> {
    try {
      loadingProgress = 10;

      await hungaryPlacesSearch.preload((progress) => {
        loadingProgress = 10 + progress * 0.8;
      });

      placesDataLoaded = true;
      loadingProgress = 90;

      setTimeout(() => {
        loadingProgress = 100;
        setTimeout(() => {
          firstLoadFinish = true;
        }, 500);
      }, 1000);
    } catch (error) {
      console.error("Failed to load places data:", error);
      setTimeout(() => {
        firstLoadFinish = true;
      }, 3000);
    }
  }

  function cleanup(): void {
    mapManager?.destroy();
  }
</script>

<div
  bind:this={mapElement}
  id="map"
  class="absolute inset-0 w-full h-full"
></div>

{#if poiStore.isLoading || !firstLoadFinish}
  <MapLoadScreen {loadingProgress} {firstLoadFinish} />
{/if}

<!-- TODO: handle gracefully... -->
{#if poiStore.error && false}
  <div
    class="absolute top-4 right-4 bg-red-100 border border-red-400 text-red-700 px-3 py-2 rounded-lg shadow-md"
  >
    <span class="text-sm">{poiStore.error}</span>
  </div>
{/if}

<MapControl class="fixed right-4 bottom-4" map={mapManager?.getMap()} />

<style>
  @keyframes float {
    0%,
    100% {
      transform: translateY(0px);
    }
    50% {
      transform: translateY(-20px);
    }
  }
</style>
